'use client';
import { CatChip } from '@blocks-react/components/Chip';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from './DealerLocatorFiltersServiceOfferingsChips.module.scss';
import { v4 as uuid } from 'uuid';

export interface DealerLocatorFiltersServiceOfferingsChipsProps {
  options: string[];
}

export const DealerLocatorFiltersServiceOfferingsChips = ({
  options
}: DealerLocatorFiltersServiceOfferingsChipsProps) => {
  const { setValue, watch } = useFormContext();

  const optionsValues = watch('options');
  const handleChipClicked = useCallback(
    (index: number) => {
      const newOptions = [...watch('options')];
      newOptions[index] = !newOptions[index];
      setValue('options', newOptions, { shouldDirty: true });
    },
    [watch, setValue]
  );

  return (
    <div className={styles['chips-container']}>
      {optionsValues.map((optionValue: string, index: number) => (
        <CatChip
          className="mr-3"
          key={`chip-${uuid()}`}
          isActive={!!optionValue}
          onBlChipSelect={() => handleChipClicked(index)}
        >
          {options[index]}
        </CatChip>
      ))}
    </div>
  );
};
